module.exports = __webpack_public_path__ + "static/media/001_ar_11.b5c9f1ae.mp4";